import {Currency} from 'types';

export const toPrecision = (base: number, value: number, parse?: boolean) => {
    let precision = base;
    if (value < 1) {
        precision = 1;
    } else if (value < 10) {
        precision = 2;
    } else if (value < 100) {
        precision = 3;
    } else if (value < 1000) {
        precision = 4;
    } else {
        precision = 5;
    }

    const result = value.toPrecision(precision);

    return parse ? Number.parseFloat(result) : result;
};

export const stripLetters = (value: string) => value.replaceAll(/\D+/g, '');

export const toCurrency = ({
    currency,
    value,
}: {
    currency: Currency;
    value: bigint | number;
}) =>
    new Intl.NumberFormat('en-US', {
        currency,
        style: 'currency',
    }).format(value);

export const clamp =
    ({max, min}: {max: number; min: number}) =>
    (value: number) =>
        Math.min(Math.max(min, value), max);

export const withinRange =
    ({max, min}: {max: number; min: number}) =>
    (value: number | string): boolean =>
        value === '' ||
        value === '-' ||
        (Number(value) >= min && Number(value) <= max);

export const toIntWithCommas = (number: number | string) => {
    const intValue = Number.parseInt(String(number), 10);

    if (Number.isNaN(intValue)) return 0;

    return intValue.toLocaleString();
};
